// extracted by mini-css-extract-plugin
export default {"root":"Peek_root__0ExyD","top":"Peek_top__xIbdq","right":"Peek_right__e8qNq","left":"Peek_left__kuGH5"};